import request from '@/apis/request'
const resource = 'banners' 

export default {
  get: (params = {}) => {
    return request.get(`${resource}`, { params })
  }, 
}